// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
export const stripDiacritics = (str: string) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
